import { Component, Host, h, State, Element, Listen, Prop } from '@stencil/core';
import { clickOutsideOfElementListener } from '../../../utils/clickOutsideOfElementListener';
import { getCurrentMediaQuery } from '../../../utils/getCurrentMediaQuery';

@Component({
    tag: 'sew-ws-image-zoom',
    styleUrl: 'sew-ws-image-zoom.scss',
    shadow: true,
})
export class SewWsImageZoom {
    @Element() host: HTMLSewWsImageZoomElement;

    @Prop() closeAriaLabel = 'close';
    @Prop() zoomAriaLabel = 'zoom';

    @State() isOpen = false;
    @State() scrolled = false;

    @Listen('scroll', { target: 'window' })
    onScroll() {
        if (window.scrollY > 1) {
            this.scrolled = true;
        } else {
            this.scrolled = false;
        }
    }

    componentDidLoad(): void {
        clickOutsideOfElementListener(this.host, () => (this.isOpen = false));
        this.host
            .querySelector('[slot=preview]')
            .shadowRoot.querySelector('picture')
            .addEventListener('click', () => {
                if (getCurrentMediaQuery() > 1) {
                    this.isOpen = true;
                }
            });
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                this.isOpen = false;
            }
        });
    }

    componentWillRender(): void {
        document.body.classList.toggle('sew-modal-open', this.isOpen);
    }

    render() {
        return (
            <Host class={{ scrolled: this.scrolled }}>
                <slot name="preview"></slot>
                <button aria-label={this.zoomAriaLabel} class="zoom-btn">
                    <sew-icon class="svg" icon="zoom-out-map" width="48" height="48" size="xl"></sew-icon>
                </button>
                <dialog open={this.isOpen}>
                    <div class="grid">
                        <button
                            aria-label={this.closeAriaLabel}
                            class="close-btn"
                            onClick={() => (this.isOpen = false)}
                        >
                            <sew-icon class="svg" icon="close" />
                        </button>
                        <slot name="zoom"></slot>
                    </div>
                </dialog>
            </Host>
        );
    }
}
